// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* About styles */

#hero {
  overflow: hidden;
  width: 100vw;
  height: auto;
}

#hero img {
  object-fit: contain;
  object-position: center;
  max-width: 100%;
  height: auto;
}

#about-me-title {
  display: flex;
  justify-content: center;
}

#p-about {
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/components/pages/About/About.css"],"names":[],"mappings":"AAAA,iBAAiB;;AAEjB;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":["/* About styles */\n\n#hero {\n  overflow: hidden;\n  width: 100vw;\n  height: auto;\n}\n\n#hero img {\n  object-fit: contain;\n  object-position: center;\n  max-width: 100%;\n  height: auto;\n}\n\n#about-me-title {\n  display: flex;\n  justify-content: center;\n}\n\n#p-about {\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
